export enum TipoEnviadaPorEmail {
  DIGITAL = 'S',
  FISICA = 'N',
}
